import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { BaseCampaign } from '@feathr/blackbox';
import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

const EmailHardBouncesColumn: IColumn<BaseCampaign> = {
  id: 'stats_cache__flavors__pinpoint_tracked_email_hardbounce',
  checkboxLabel: 'Hard Bounces',
  Header: TableColumnHeader({
    title: 'Hard Bounces',
  }),
  width: 110,
  sortable: false,
  className: tableStyles.cellRight,
  Cell({ original }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const stats = original.get('stats_cache');
          const flavors = stats?.flavors || {};
          const hardBounces = flavors.pinpoint_tracked_email_hardbounce || 0;
          return <>{hardBounces.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
  Footer({ data }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const total = data.reduce((subtotal, currentValue) => {
            const stats = currentValue._original.get('stats_cache');
            const flavors = stats?.flavors || {};
            const hardBounces = flavors.pinpoint_tracked_email_hardbounce || 0;
            return subtotal + Math.max(0, hardBounces);
          }, 0);
          return <>{total.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
};

export default EmailHardBouncesColumn;
